/*
=========================================================
* Material Kit 2 React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React examples
import DefaultNavbar from "bachrosenComponents/bachNavbar";
import CenteredFooter from "bachrosenComponents/centeredFooter";
// import HorizontalBlogCard from "examples/Cards/BlogCards/HorizontalBlogCard";
import BachHeader from "bachrosenComponents/bachHeader";
import BachCenteredBlogCard from "bachrosenComponents/bachCenteredBlogCard";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

// Images
import bgImage from "assets/images/home1.jpg";
import imgGruppenbild1972 from "assets/images/gruppenbild-1972.jpg";
import imgGruppenbild1993 from "assets/images/gruppenbild-1993.jpg";
import imgGruppenbild1999 from "assets/images/gruppenbild-1999.jpg";
import imgGruppenbild2008 from "assets/images/gruppenbild-2008.JPG";
import imgGruppenbild2023 from "assets/images/gruppenbild-2023.jpg";

function HistorySite() {
  const history = `
    Der Brauchtumsverein Bachrose Bietingen e.V. ist in Bietingen, einem
    beschaulichen Ort zwischen Bodensee und Donautal, daheim. 
    Mit ca. 220 Einwohnern ist Bietingen der kleinste Ort der Gemeinde Sauldorf. <br><br>
    Durch das Dorf fließt ein idyllischer Bach, der Rosenbach. Am Ufer blühen im Frühjahr
    unzählige gelbe Bachrosen. Diese Blütenpracht und der Rosenbach gaben dem
    Verein den Namen Bachrose. <br><br>
    Die Zunft ist in mehrere Gruppen unterteilt. <br>
    Zum einen die Bachrosen. Sie tragen einen langen, grünen Rock, eine gelb-grüne
    Jacke und einen gelb-grünen, blütenförmigen Hut. Die Bachrosen haben stets
    einen Korb mit leckeren Naschereien dabei. Vor Regen und Schnee schützen sie
    sich mit einem Schirm. <br>
    Den Bachrosen folgen die Gärtner. Sie sind für die
    Pflege und das gute Gedeihen der Bachrosen verantwortlich. Mit ihren schwarzen
    Kniebundhosen, einem hellgrünen Hemd und einer grünen Schürze treiben sie so
    manchen Schabernack. Ihr Kopf ist von einer Halbmaske und einem Hut mit buntem
    Haar bedeckt. <br><br>
    Im Umzug läuft der Narrenpolizist vorneweg. Er trägt eine blaue
    Uniform und eine blaue Schildmütze. <br>
    Ihm folgt der Elferrat in grünen Mänteln
    und einem Landsknechthut. <br>
    Den Schluss bilden die Bachrosen und die Gärtner.
  `;

  const chronic = `
  Herkunft des Namens: Durch das Dorf fließt der Rosenbach.
  Der Zunftname entstand durch Verdrehung des Bachnamens. <br><br>
  bis 1949: Gestaltung der Ortsfasnet durch die örtlichen Vereine. <br>
  1949: Gründung eines Narrenvereins "Lebewohl Hühnerauge". <br>
  1967: Der Verein wird in "Verein örtlichen Brauchtums 1963" umbenannt. <br>
  1972: Erneute Umbenennung in "Brauchtumsverein Bachrose Bietingen". <br>
  1978: Bachrosen und Gärtner erhalten ein eigenes Zunfthäs. <br>
  1988: neues Häs und Holzmasken werden angeschafft. <br><br>
  Narrenruf Narri Narro
  `;

  return (
    <>
      <MKBox position="fixed" top="0.5rem" width="100%">
        <DefaultNavbar routes={routes} dark info center />
      </MKBox>
      <BachHeader image={bgImage} title="Unsere Geschichte" />
      <Card
        sx={{
          // p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <Container>
          <Grid container spacing={3} mb={0}>
            <Grid item xs={12} lg={6}>
              <MKBox mb={1}>
                <MKBox
                  bgColor="white"
                  borderRadius="xl"
                  shadow="lg"
                  display="flex"
                  flexDirection="column"
                  justifyContent="center"
                  mt={{ xs: 10, sm: 9, md: 10 }}
                  mx={1}
                >
                  <MKBox
                    variant="gradient"
                    bgColor="success"
                    coloredShadow="success"
                    borderRadius="lg"
                    p={2}
                    mx={2}
                    mt={-3}
                  >
                    <MKTypography variant="h3" color="white">
                      Der Verein
                    </MKTypography>
                  </MKBox>
                  <MKBox p={3}>
                    <MKTypography
                      variant="body2"
                      color="text"
                      mb={3}
                      dangerouslySetInnerHTML={{ __html: history }}
                    />
                  </MKBox>
                </MKBox>
              </MKBox>
            </Grid>
            <Grid item xs={12} lg={6}>
              <MKBox mb={1}>
                <MKBox
                  bgColor="white"
                  borderRadius="xl"
                  shadow="lg"
                  display="flex"
                  flexDirection="column"
                  justifyContent="center"
                  mt={{ xs: 10, sm: 9, md: 10 }}
                  mb={{ xs: 0, sm: 0, md: 0 }}
                  mx={1}
                >
                  <MKBox
                    variant="gradient"
                    bgColor="success"
                    coloredShadow="success"
                    borderRadius="lg"
                    p={2}
                    mx={2}
                    mt={-3}
                  >
                    <MKTypography variant="h3" color="white">
                      Chronik
                    </MKTypography>
                  </MKBox>
                  <MKBox p={3}>
                    <MKTypography
                      variant="body2"
                      color="text"
                      mb={3}
                      dangerouslySetInnerHTML={{ __html: chronic }}
                    />
                  </MKBox>
                </MKBox>
              </MKBox>
            </Grid>
          </Grid>

          {/* Gruppenbilder:  */}
          <Grid container spacing={3} alignItems="center" justifyContent="center" mt={0} mb={8}>
            <Grid item xs={12} sm={6} md={6} lg={6} xl={6} mt={8}>
              <BachCenteredBlogCard image={imgGruppenbild1972} title="Gruppenbild 1972" />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6} xl={6} mt={8}>
              <BachCenteredBlogCard image={imgGruppenbild1993} title="Gruppenbild 1993" />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6} xl={6} mt={8}>
              <BachCenteredBlogCard image={imgGruppenbild1999} title="Gruppenbild 1999" />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6} xl={6} mt={8}>
              <BachCenteredBlogCard image={imgGruppenbild2008} title="Gruppenbild 2008" />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6} xl={6} mt={8}>
              <BachCenteredBlogCard image={imgGruppenbild2023} title="Gruppenbild 2023" />
            </Grid>
          </Grid>
        </Container>
      </Card>
      <MKBox px={1} mt={6}>
        <CenteredFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default HistorySite;
